
<template>

 
        <input :type="InputType"
               v-model="m_Value"
               v-on:input="OnValueInput"
               v-on:change="OnValueChange"
               v-on:click="OnClick"
               v-on:blur="OnBlur"

               :readonly="FinalReadOnly"
               :DataType="m_Attribute.DataType"
               :nullable="(!FinalRequired)+''"

               :disabled="FinalEnabled == false"
               
               :MinLength="m_Attribute.MinLength"
               :MaxLength="m_Attribute.MaxLength"

               :MinValue="m_Attribute.MinValue"
               :MaxValue="m_Attribute.MaxValue"
               
               v-show="FinalVisible"
               ref="Element" />
   
      
     
  
</template>

<script>
    import Utility from '@/Common/Utility'
    import TControlBase from '@/Common/TControlBase';

    export default {
        data() {
            return {
                m_Value: "",

                m_Type: "",

                m_Attribute: TControlBase.Attribute({
                    Nullable: false,
                    Enabled: true,
                    Visible: true,
                    ReadOnly: false,
                    MaxLength: null,
                    AutoTrim: false
                    }
                )
            };
        }
        ,
        //props: ["value", "nullable" , "enabled" , "AutoTrim", "Attribute", "MinValue", "MaxValue", "Keep","KeyName"],

        props: [...TControlBase.BaseProps],

        computed: {

            InputType: {
                get: function () {
                    let inputType = "text";

                    if (this.IsDataTypeNumber()) {
                        inputType = "Number";
                    }

                    return inputType;
                }
            },

 
        }
        ,

        methods: {

            OnClick: function (e) {
                this.$emit("click", e);
            },

            //GetValue() {
            //    return this.m_Value;
            //},

            //SetValue(value) {
            //    this.m_Value = value;
            //    this.$emit("input", value);
            //},

            OnBlur(e) {
                //let trimValue = "";


                //if (this.AutoTrim == "true") {

                //    trimValue = e.target.value.trim();
                //    e.target.value = trimValue;
                //    this.$emit("input", trimValue);

                //}

                //if (this.KeyName != null && this.KeyName != "") {
                //    this.StoreValue();
                //}

                this.$emit("blur");
            },


            OnValueInput(e) {

                this.DoOnValueInput(e);
                //if (this.$refs.Element.nextSibling != null) {
                //    if (this.$refs.Element.nextSibling.nodeType == 1) {
                //        if (this.$refs.Element.nextSibling.classList.contains("error_message")) {
                //            this.$refs.Element.nextSibling.innerHTML = "";
                //        }
                //    }
                //}

                //this.$emit("input", e.target.value);
            },


            OnValueChange(e) {
                this.DoOnValueChange(e);
                //if (this.$refs.Element.nextSibling != null) {
                //    if (this.$refs.Element.nextSibling.nodeType == 1) {
                //        if (this.$refs.Element.nextSibling.classList.contains("error_message")) {
                //            this.$refs.Element.nextSibling.innerHTML = "";
                //        }
                //    }
                //}
                 
                //this.$emit("change", e.target.value);
            },

            UpdateElementByAttribute() {

            },
 

        },

        mounted() {
            this.DoOnMounted();
        },


        created() {
            TControlBase.call(this);

            //if (this.enabled != null) {
            //    if (this.enabled == "true" || this.enabled == "True" || this.enabled == true) {
            //        this.m_Attribute.Enabled = true;
            //    }
            //    else {
            //        this.m_Attribute.Enabled = false;
            //    }
            //}

            //if (this.nullable == "false" || this.nullable == false) {
            //    this.m_Attribute.Nullable = false;
            //}
            //else {
            //    this.m_Attribute.Nullable = true;
            //}

            //if (this.value == null) {
            //    this.m_Value = "";
            //}
            //else {
            //    this.m_Value = this.value;
            //}

            //if (this.Attribute != null) {
            //    Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
            //}

            //if (this.Keep == true || this.Keep == "true") {
            //    this.LoadValue();
            //}
        },

        watch: {
            //Attribute: function (newVal, oldVal) {
            //    Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);
            //},

            //nullable: function (newVal, oldVal) {
            //    this.m_Attribute.Nullable = newVal;
            //},

            //enabled: function (newVal) {
            //    if (newVal != null) {
            //        if (newVal == "true" || newVal == "True" || newVal == true) {
            //            this.m_Attribute.Enabled = true;
            //        }
            //        else {
            //            this.m_Attribute.Enabled = false;
            //        }
            //    }
            //} ,

            //value: function (newVal, oldVal) {

            //    if (newVal == null) {
            //        this.m_Value = "";
            //    }
            //    else {
            //        this.m_Value = newVal;
            //    }


            //    if (this.Keep == true || this.Keep == "true") {
            //        this.StoreValue();
            //    }
            //    this.ClearError();
            //}
        }


    }
</script>

<style scoped>
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
